
export class VehicleBrandsModel {
    id: number;
    vehicleID: number;
    brandID: number;
    jurisdictionID: number;
    effectiveDate: Date;
    effectiveDateString: string;
    endDate: Date;
    brandAppliedDate: Date;
    rowId: number;
    readOnly = true;
}
